export default __webpack_public_path__ + "static/media/Stock-BuyBack-New.595fe056.svg";